export default function PreparationNotes() {
  return (
    <div className="space-y-2">
      <h3 className="text-md font-medium">What to have ready</h3>
      <ul className="marker:text-charcoal-500 list-disc pl-4 text-sm">
        <li>List of current medications</li>
        <li>Recent vitals (height, weight, waist size)</li>
        <li>Relevant medical history (diagnoses, symptoms, allergies)</li>
      </ul>
    </div>
  );
}
